import {
    effect,
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    WritableSignal,
    signal,
    ChangeDetectorRef
} from '@angular/core';
import { DatePickerModule } from 'primeng/datepicker';
import {
    FormsModule,
    ReactiveFormsModule,
    FormBuilder,
    FormGroup,
    FormControl
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import {
    faArrowRightToBracket,
    faArrowRightFromBracket,
    faTrash
} from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '@angular/common';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { timeout } from 'rxjs';
import { HistogramaComponent } from '../../../../shared/components/histograma/histograma/histograma.component';
import {
    TableRow,
    TableColumn
} from '../../../../shared/models/components/tables/table.models';
import { InputsTableComponent } from '../model-predictions/inputs-table/inputs-table.component';
import { MatButtonModule } from '@angular/material/button';
import { ResultsTableComponent } from '../model-predictions/results-table/results-table.component';
import { SharedDataService } from '../../../../shared/services/shared-data.service';
import { DividerModule } from 'primeng/divider';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ModelAccuracyService } from '../../../../shared/services/componentsServices/modelAccuracy.service';
import { modelAccuracyResponse } from '../../../../shared/models/serviceModels/response/model-accuracy-response.model';
import { ModelAccuracyModel } from '../../../../shared/models/serviceModels/request/modelAccuracyReq.model';
import { LoadingButtonComponent } from '../../../../shared/components/loading-button/loading-button.component';
import { NotificationPopupComponent } from '../../../../shared/components/notification-popup/notification-popup.component';

@Component({
    selector: 'app-model-accuracy',
    imports: [
        LoadingButtonComponent,
        NotificationPopupComponent,
        DatePickerModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FontAwesomeModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        // MatDateRangePicker,
        HistogramaComponent,
        // InputsTableComponent,
        MatButtonModule,
        ResultsTableComponent,
        DividerModule
    ],
    templateUrl: './model-accuracy.component.html',
    styleUrl: './model-accuracy.component.scss'
})
export class ModelAccuracyComponent implements OnInit {
    @ViewChild('startInput') startInput!: ElementRef;
    @ViewChild('endInput') endInput!: ElementRef;
    @ViewChild('dateRangePicker') dateRangePicker!: MatDateRangePicker<any>;
    faXmark = faXmark;

    selectedDates: Date[] | null = null;
    excludedDates: Date[] = [];
    faArrowRightToBracket = faArrowRightToBracket;
    faArrowRightFromBracket = faArrowRightFromBracket;
    faTrash = faTrash;
    testDate: Date | null = null;
    baseScenario: WritableSignal<TableColumn | null> = signal(null);
    differencePercentage: string = '';
    differenceValue: string = '';
    selectedStrategy: string = '';
    exitDifferencePercentage: string = '';
    exitDifferenceValue: string = '';
    stopLossPercentage: string = '';
    stopLossValue: string = '';
    takeProfitPercentage: string = '';
    takeProfitValue: string = '';
    range: FormGroup;
    exclusionDateRanges: { start: Date; end: Date }[] = [];

    columnsAllTradesCopy: TableRow[] = [];
    isVisible = false;
    predictionDate: Date | undefined;
    selectedDate: string = '';
    selectedRanges: WritableSignal<TableColumn | null> = signal(null);

    rangeDates: Date[] | null = null;
    modelAccuracyData: any[] = [];
    predictionRange: Date[] | null = null;

    isButtonDisabled: boolean = true;
    isSpinnerVissible = signal(false);

    isNotificationPopupOpen = signal(false);
    errorMessage: WritableSignal<string> = signal('');
    secondErrorMessage: WritableSignal<string> = signal('');

    constructor(
        private fb: FormBuilder,
        private SharedDataService: SharedDataService,
        private ModelAccuracyService: ModelAccuracyService,
        private library: FaIconLibrary,
        private cd: ChangeDetectorRef
    ) {
        this.range = this.fb.group({
            start: [null],
            end: [null]
        });

        this.columnsAllTradesCopy =
            this.SharedDataService.getOriginalRowsAllTradesModelAccuracy();
        effect(
            () => {
                this.rowsAllTrades =
                    this.SharedDataService.getRowsAllTradesModelAccuracy();
            }
        );
    }

    ngOnInit(): void {
        this.setRunDateRange();
        this.exclusionDateRanges =
            this.ModelAccuracyService.getExclusionDateRanges();
        this.setCachedDataInUi();
    }

    closeNotificationPopup() {
        this.isNotificationPopupOpen.set(false);
    }

    setRunDateRange() {
        const savedRange =
            this.ModelAccuracyService.getCurrentPredictionRange();
        const validRange = this.normalizeDateRange(savedRange);
        if (validRange) {
            this.predictionRange = [
                new Date(validRange[0]),
                new Date(validRange[1])
            ];
            this.cd.detectChanges();
            this.isButtonDisabled = false;
        }
    }

    setCachedDataInUi() {
        this.rowsAllTrades =
            this.SharedDataService.getRowsAllTradesModelAccuracy();

        if (this.rowsAllTrades().length > 0) {
            this.isVisible = true;
            this.isButtonDisabled = false;
        }
    }

    formatRange(start: Date | null | undefined, end: Date | null | undefined): string {
        if (!(start instanceof Date) || isNaN(start.getTime())) {
            return '';
        }

        if (!(end instanceof Date) || isNaN(end.getTime())) {
            return '';
        }

        return `${formatDate(start, 'MMMM d, yyyy', 'en-US')} - ${formatDate(
            end,
            'MMMM d, yyyy',
            'en-US'
        )}`;
    }

    toggleVisibility() {
        this.isVisible = !this.isVisible;
    }

    getModelAccuracyData() {
        const excludedDates: Date[] = [];
        this.isSpinnerVissible.set(true);

        const validRange = this.normalizeDateRange(this.predictionRange);
        if (!validRange) {
            this.isSpinnerVissible.set(false);
            return;
        }

        this.exclusionDateRanges.forEach((range) => {
            const current = new Date(range.start);
            const end = new Date(range.end);

            while (current <= end) {
                excludedDates.push(new Date(current));
                current.setDate(current.getDate() + 1);
            }
        });

        const modelAccuracyModel: ModelAccuracyModel = {
            startDate: validRange[0],
            endDate: validRange[1],
            excludedDates: excludedDates.length > 0 ? excludedDates : undefined
        };

        this.ModelAccuracyService.getModelAccuracy(
            modelAccuracyModel
        ).subscribe((response: modelAccuracyResponse) => {
            this.isSpinnerVissible.set(false);

            if (
                response.errorMsg.length > 0 ||
                response.modelAccuracies.length === 0
            ) {
                // if(response.errorMsg !== null && response.errorMsg !== undefined){
                this.isVisible = false;
                let errorMsg =
                    response.errorMsg.length > 0
                        ? response.errorMsg
                        : 'there are no data for the selected range.';
                this.handleErrorMessage(
                    errorMsg,
                    'Please select a new date range and try again.'
                );

                return;
            }

            this.setDataInUi(response);
        });
    }

    setDataInUi(response: modelAccuracyResponse) {
        const mappedData: TableRow[] = response.modelAccuracies.map((item) => ({
            field: item.id.toString(),
            date: new Date(item.runDate || ''),
            predictedDate: new Date(item.predictionDate || ''),
            // date: this.formatDate(new Date(item.runDate || '')),
            predictedValue: item.prediction?.toFixed(2) || '-',
            actualValue: item.actual?.toFixed(2) || '-',
            error: item.error,
            // error: item.error?.toFixed(2) || '-',
            absoluteError: item.absoluteError,
            // absoluteError: item.absoluteError?.toFixed(2) || '-',
            inputId: ''
        }));

        // stores data to be shown in the table
        this.SharedDataService.setRowsAllTradesModelAccuracy(mappedData);

        //stores original data to be used in the table
        this.SharedDataService.setOriginalRowsAllTradesModelAccuracy([
            ...mappedData
        ]);

        this.columnsAllTradesCopy = [...this.rowsAllTrades()];

        this.isVisible = true;
    }

    handleErrorMessage(errorMessage: string, secondErrorMessage: string = '') {
        let errorMsg = `An error occurred while running the model: ${errorMessage}`;
        this.errorMessage.set(errorMsg);
        this.secondErrorMessage.set(secondErrorMessage);
        this.isNotificationPopupOpen.set(true);
    }

    removeRange(index: number): void {
        this.exclusionDateRanges.splice(index, 1);
        this.ModelAccuracyService.setExclusionDateRanges(
            this.exclusionDateRanges
        );
    }

    // onApplyClick(startInput: HTMLInputElement, endInput: HTMLInputElement): void {
    //   const start = startInput.value;
    //   const end = endInput.value;
    //   if (start && end) {
    //     this.dateRanges.push({
    //       start: new Date(start),
    //       end: new Date(end)
    //     });

    //   }
    // }
    onCancelClick(
        startInput: HTMLInputElement,
        endInput: HTMLInputElement
    ): void {
        startInput.value = '';
        endInput.value = '';
    }

    columnsAllTrades: WritableSignal<TableColumn[]> = signal([
        {
            header: 'Run date',
            field: 'date',
            editable: false,
            deletable: false,
            isFrozen: false,
            name: 'Date'
        },
        {
            header: 'Predicted month',
            field: 'predictedDate',
            editable: false,
            deletable: false,
            isFrozen: false,
            name: 'Date'
        },
        {
            header: 'Predicted value',
            field: 'predictedValue',
            editable: false,
            deletable: false,
            isFrozen: false,
            name: 'Position direction'
        },
        {
            header: 'Actual value',
            field: 'actualValue',
            editable: false,
            deletable: false,
            isFrozen: false,
            name: 'Entry price'
        },
        {
            header: 'Error',
            field: 'error',
            editable: false,
            deletable: false,
            isFrozen: false,
            name: 'Exit price'
        },
        {
            header: 'Absolute error',
            field: 'absoluteError',
            editable: false,
            deletable: false,
            isFrozen: false,
            name: 'Exit strategy'
        }
    ]);

    rowsAllTrades: WritableSignal<TableRow[]> = signal([]);

    reset(): void {
        this.SharedDataService.setRowsAllTradesModelAccuracy(
            this.columnsAllTradesCopy
        );
    }

    onDateRangeChange(event: any) {
        const validRange = this.normalizeDateRange(this.rangeDates);

        if (!validRange || this.exclusionDateRanges.length === 5) {
            return;
        }

        const [startDate, endDate] = validRange;

        let isInRange = this.isWithinRange(
            new Date(startDate),
            new Date(endDate)
        );

        if (isInRange) {
            return;
        }

        this.exclusionDateRanges.push({
            start: new Date(startDate),
            end: new Date(endDate)
        });
        this.ModelAccuracyService.setExclusionDateRanges(
            this.exclusionDateRanges
        );

        this.rangeDates = null;
    }

    onRunRangeChange(event: any) {
        const validRange = this.normalizeDateRange(this.predictionRange);

        if (!validRange) {
            return;
        }

        this.predictionRange = [new Date(validRange[0]), new Date(validRange[1])];
        this.ModelAccuracyService.setCurrentPredictionRange([
            new Date(validRange[0]),
            new Date(validRange[1])
        ]);
        this.isButtonDisabled = false;
    }

    private normalizeDateRange(range: Date[] | (Date | null | undefined)[] | null | undefined): [Date, Date] | null {
        if (!Array.isArray(range) || range.length < 2) {
            return null;
        }

        const start = range[0];
        const end = range[1];

        if (!(start instanceof Date) || isNaN(start.getTime())) {
            return null;
        }

        if (!(end instanceof Date) || isNaN(end.getTime())) {
            return null;
        }

        return [start, end];
    }

    isRunButtonDisabled() {
        return this.isButtonDisabled;
    }

    isWithinRange(start: Date, end: Date): boolean {
        for (const range of this.exclusionDateRanges) {
            if (start >= range.start && end <= range.end) {
                return true;
            }
        }
        return false;
    }

    onDateChange(event: any) {
        const selectedDate = new Date(event);
        let currentDate = this.formatDate(selectedDate);
        this.selectedDate = currentDate;
        this.predictionDate = selectedDate;
    }

    formatDate(date: Date): string {
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        return date.toLocaleDateString('en-US', options);
    }
}
